const ScrollPage = () => {
  const mainCont = document.querySelector('.app');
  return mainCont.scrollTo(0, 0);
};

export default ScrollPage;
